/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import GoHighLevel from './GoHighLevelLogo.png';

export const GoHighLevelIcon = ({ className }: { className: string }) => (
  <img
    className={classNames(className)}
    src={GoHighLevel}
    alt="GoHighLevelLogo"
  />
);
